import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-body" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_5 = { class: "col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)

import { useRouter } from "vue-router";
import "@aws-amplify/ui-vue/styles.css";
import { useAuthStore } from "@/auth/store";
import { Hub } from "aws-amplify";
import { Auth } from "aws-amplify";
import SimpleButton from "@/shared/components/SimpleButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();

function signIn() {
  Auth.federatedSignIn({ provider: "Google" });
}
Hub.listen("auth", async ({ payload: { event } }) => {
  if (event === "signIn") {
    const is_auth = await authStore.checkAuthenticated();
    if (is_auth) {
      router.replace({ name: "home", query: {} });
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SimpleButton, {
            color: "primary",
            onClick: signIn
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sign In with Google ")
            ]),
            _: 1
          })
        ]),
        _hoisted_6
      ])
    ])
  ]))
}
}

})